import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import './index.scss';
import store from 'shared/store';
import { loadStateAction } from 'shared/store/actions';
import savedStates from 'shared/store/savedStates';
import App from './App';
import * as serviceWorker from './serviceWorker';

const history = createBrowserHistory();

/** Action to load state based on keys */
const loadState = (savedState) => {
  store.dispatch(loadStateAction(savedState));
};

document.onkeyup = (e) => {
  if (e.altKey && e.which === 49) {
    console.log('ALT+1 shortcut detected, loadingState: ', savedStates.dataWithSkipIds);
    loadState(savedStates.dataWithSkipIds);
  }
};

ReactDOM.render(
  <Router basename={process.env.PUBLIC_URL} history={history}>
    <App />
  </Router>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
